import script from "./BasketByCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./BasketByCategory.vue?vue&type=script&setup=true&lang=js"

import "./BasketByCategory.vue?vue&type=style&index=0&id=22c320d6&scoped=true&lang=css"

import exportComponent from "/Users/darrenlumber/Sites/office-drop-craft/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22c320d6"]])

export default __exports__